import TagManager from 'react-gtm-module';

export const useSocialMediaTag = ({ label }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_social_media',
      category: 'UI Interaction',
      action: 'Click',
      label
    }
  });
